import React from 'react';
import { CreditCard } from 'lucide-react';
import { getCreditCost } from '../../config/creditCosts';

/**
 * Component to display the credit cost of a feature
 * @param {string} feature - Feature name
 * @param {string} className - Additional CSS classes
 */
const FeatureCostBadge = ({ feature, className = '' }) => {
  const cost = getCreditCost(feature);
  
  return (
    <div className={`inline-flex items-center px-2 py-1 bg-[#F0F7FF] text-[#1A202C] rounded-full shadow-sm border border-[#D1E2FB] hover:shadow-md transition-all ${className}`}>
      <CreditCard className="w-3 h-3 mr-1 text-[#5E60CE]" />
      <span className="text-xs font-semibold">
        {cost} {cost === 1 ? 'Credit' : 'Credits'}
      </span>
    </div>
  );
};

export default FeatureCostBadge; 